export default "__VITE_ASSET__BQYHNYSP__"